<template>
    <section class="features-section">
      <div class="features-container">
        <!-- Main Headings -->
        <div class="features-header">
          <h2 class="main-heading-services" :class="$i18n.locale === 'ar' ? 'arabic-text' : ''" >{{$t('landing_page_promo_text')}}</h2>
          <p class="description">{{$t('landing_page_promo_text_subtitle')}}</p>
        </div>
  
        <!-- Service Cards -->
        <div class="services-grid">
          <div 
            v-for="service in services" 
            :key="service.id"
            class="service-card"
            :class="service.className"
            @click="goToPage(service.path)"
          >
            <div class="service-icon">
              <img :src="service.icon" :alt="$t(service.title)">
            </div>
            <div class="service-content">
              <h4 class="service-title">{{ $t(service.title) }}</h4>
              <p class="service-description">{{ $t(service.description) }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </template>
  
  <script>
  export default {
    name: 'KidjoFeatures',
    data() {
      return {
        websiteUrl: process.env.VUE_APP_WEBSITE_URL,
        excludedLang: ['ar', 'it', 'pt', 'en'],
        services: [
          {
            id: 1,
            title: 'Kidjo TV',
            description: 'landing_page_video_promo',
            icon: require('../assets/logo/TV.webp'),
            className: 'tv-card',
            path: 'kidjo-tv'
          },
          {
            id: 2,
            title: 'Kidjo Stories',
            description: 'landing_page_stories_promo',
            icon: require('../assets/logo/Stories.webp'),
            className: 'stories-card',
            path: 'kidjo-stories'
          },
          {
            id: 3,
            title: 'Kidjo Games',
            description: 'landing_page_games_promo',
            icon: require('../assets/logo/Games.webp'),
            className: 'games-card',
            path: 'kidjo-games'
          }
        ]
      }
    },
    
    methods: {
      goToPage(selectedPath) {
        if (!selectedPath) return;
        // this.$store.dispatch('postAnalytics', Events.EXIT);
        window.location.href =  this.ifInExcludedLang() ? this.websiteUrl + `/${selectedPath}` : this.websiteUrl + `/${this.$i18n.locale}/${selectedPath}`;
      },
      ifInExcludedLang () {
          return this.excludedLang.includes(this.$i18n.locale);
      }
    }
  }
  </script>
  
  <style scoped>
  .features-section {
    padding-bottom: 2rem;
    padding-top: 3rem;
    background-color: #ffffff;
  }
  
  .features-container {
    max-width: 95%;
    margin: 0 auto;

    @media (orientation: portrait) {
      max-width: 96%;
    }
    @media (min-width: 1024px) {
      max-width: 65%;
    }
    @media (min-width: 921px) and (max-width: 1024px) {
      max-width: 85%;
    }
  }
  
  .features-header {
    margin-bottom: 1rem;
    display: grid;
    text-align: center;
    justify-content: center;
    align-items: center;
    padding-inline: 0.6rem;
  }
  
  .main-heading-services {
    color: #020076;
    font-size: 2.5rem;
    font-weight: bold;
    margin-bottom: 1rem;
    line-height: 1; /* Adjust line-height if necessary */
    text-align: center; /* Centers the text horizontally */
    word-wrap: break-word; /* Allows the text to break into multiple lines */
    max-width: 800px;
    font-family: 'Nunito-ExtraBold';

    @media (orientation: portrait) {
      font-size: 1.5rem;
    }
  }
  .sub-heading {
    color: #020076;
    font-size: 1.5rem;
    font-weight: normal;
    margin-bottom: 1rem;
    font-family: 'Nunito-ExtraBold';
  }
  
  .description {
    color: #020076;
    font-size: 1.1rem;
    font-family: 'Nunito-regular';
  }
  
  .services-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 1rem;
  }
  
  .service-card {
    display: flex;
    align-items: center;
    padding: 0.7rem;
    border-radius: 12px;
    transition: transform 0.3s ease;
    gap: 8px;
    cursor: pointer;
  }
  
  .service-card:hover {
    transform: translateY(-5px);
  }
  .service-card:hover {
    transform: translateY(-4px) scale(1.02);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
    background-color: #e6e6e6; /* Light background to show it's interactive */
  }
  /* Card-specific styles */
  .tv-card,
  .stories-card,
  .games-card {
    background-color: var(--Colors-Neutral-10, #0200761A);

  }
  
  .service-icon {
    width: 60px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .service-icon img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  
  .service-content {
    flex: 1;
    text-align: left;
  }
  
  .service-title {
    color: #020076;
    font-size: 1.1rem;
    font-weight: bold;
    font-family: 'Nunito-ExtraBold';
  }
  
  .service-description {
    color: #020076;
    font-size: 0.88rem;
    font-family: 'Nunito-regular';
    @media (orientation: portrait) {
      font-size: 1.09rem;
    }
  }
  
  /* Responsive Design */
  @media (max-width: 1024px) {
    .main-heading-services {
      font-size: 2.4rem;
    }
  
    .sub-heading {
      font-size: 1.8rem;
    }
  }
  
  @media (max-width: 768px) {
    .services-grid {
      grid-template-columns: repeat(2, 1fr);
      gap: 1.5rem;
    }
  
    .main-heading-services {
      font-size: 2.2rem;
    }
  
    .sub-heading {
      font-size: 1.6rem;
    }
  }
  
  @media (max-width: 480px) {
    .services-grid {
      grid-template-columns: 1fr;
      gap: 1rem;
      padding-inline: 1rem;
    }
  
    .main-heading-services {
      font-size: 2rem;
    }
  
    .sub-heading {
      font-size: 1.4rem;
    }
  
    .service-card {
      padding: 0.6rem;
    }
  
    .service-icon {
      width: 70px;
      height: 70px;
    }
  }
  
  /* Animation */
  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  
  .service-card {
    animation: fadeInUp 0.5s ease forwards;
  }
  
  /* Accessibility */
  @media (prefers-reduced-motion: reduce) {
    .service-card {
      animation: none;
      transform: none;
    }
  
    .service-card:hover {
      transform: none;
    }
  }
  .feature-icon {
    width: 60px;
    height: 60px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden; /* Ensures the image stays inside */
}

.feature-icon img {
    width: 100%; /* Ensure it fills the div */
    height: 100%;
    object-fit: contain; /* Prevents edges from being cut */
    border-radius: 50%; /* Keeps the image round */
}

  </style>